"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDatePickerInput = void 0;
const Validator_1 = __importDefault(require("@opsbase/lib-validator/Validator"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const react_1 = __importDefault(require("react"));
function makeDatePickerInput(pickerValue, props) {
    const { style, disabled, noBorder, noMargin, fullWidth, white, label } = props;
    return (rProps) => {
        var _a, _b;
        rProps.inputProps.placeholder = (_b = (_a = rProps.inputProps) === null || _a === void 0 ? void 0 : _a.placeholder) === null || _b === void 0 ? void 0 : _b.split(' (a|p)m').join('');
        rProps.inputProps.style = Object.assign(Object.assign({}, (rProps.inputProps.style || {})), (style || {}));
        if (disabled) {
            return (react_1.default.createElement(TextField_1.default, { label: label, noBorder: noBorder, noMargin: noMargin, fullWidth: fullWidth, white: white, inputProps: { style: Object.assign({}, (style || {})) }, InputProps: { style: { margin: 0 } }, disabled: true, value: !!pickerValue ? rProps.inputProps.value : '- - -' }));
        }
        return (react_1.default.createElement(TextField_1.default, Object.assign({}, rProps, { label: label, noBorder: noBorder, noMargin: noMargin, fullWidth: fullWidth, white: white, validator: Validator_1.default.schemas().date, helperText: undefined })));
    };
}
exports.makeDatePickerInput = makeDatePickerInput;
exports.default = makeDatePickerInput;
